const styles = theme => ({
  app: {
    height: "100%",
    background: `linear-gradient(180deg, ${theme.palette.secondary.main} 0%, ${
      theme.palette.primary.main
    } 100%)`
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/App/styles.js